import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/肯佩德";
import { Soulmark } from "../../core/soulmark";

export class 肯佩德 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(617, "肯佩德", type.水·暗影, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "受到黑色瘴气的影响，一切似乎不那么平静，肯佩德变得躁动不安……",
            "1. 肯佩德登场后的3回合内开启【反射盾】，将受到攻击伤害的100%反弹给对手。（双方同时阵亡时自身残留1点体力）",
            "2. 当肯佩德受到的攻击伤害超过自身最大体力的1/2时，从下回合开始肯佩德进入【狂暴】状态：免疫所有异常状态，造成的伤害提升100%，所有技能先制额外+3，持续3回合。",
        ]);
        this.技能组 = [
            skill.死亡之尾,
            skill.黑暗操控,
            skill.暗影之力,
            skill.暗流深渊,
            skill.邪念潮汐断,
        ];
    }
}
